import { Link } from 'react-router-dom';
import { To } from 'history';

// material-ui
import { SxProps, useTheme } from '@mui/material/styles';
import ButtonBase from '@mui/material/ButtonBase';

// project imports
import Logo from './LogoMain';
import LogoIcon from './LogoIcon';
import { APP_DEFAULT_PATH } from 'config';

export { default as LogoHorizontalAlternative } from './LogoHorizontalAlternative';
export { default as LogoHorizontal } from './LogoHorizontal';
export { default as LogoHorizontalSubmarca } from './LogoHorizontalSubmarca';
export { default as LogoIcon } from './LogoIcon';
export { default as LogoMain } from './LogoMain';
export { default as LogoMainAsset, type LogoMainAssetProps } from './LogoMainAsset';
export { default as LogoOldSimpleSwiftSoft } from './LogoOldSimpleSwiftSoft';
export { default as LogoOldSwiftSoft } from './LogoOldSwiftSoft';
export { default as LogoPattern } from './LogoPattern';
export { default as LogoSimple } from './LogoSimple';
export { default as LogoVertical } from './LogoVertical';
export type { LogoImageProps } from './types';

// ==============================|| MAIN LOGO ||============================== //

interface Props {
  reverse?: boolean;
  isIcon?: boolean;
  sx?: SxProps;
  to?: To;
}

export default function LogoSection({ reverse, isIcon, sx, to }: Props) {
  const theme = useTheme();
  /** SVGs da marca vêm com traços brancos; em fundo claro (sidebar, header) precisam ficar pretos — igual ao login. */
  const lightGlyph =
    theme.palette.mode === 'light'
      ? {
          /** Vector da marca: traços claros; em fundo claro fica a preto (via currentColor + filtro). */
          '& .MuiSvgIcon-root': { filter: 'brightness(0)' }
        }
      : undefined;

  return (
    <ButtonBase disableRipple component={Link} to={to || APP_DEFAULT_PATH} sx={[lightGlyph, ...(Array.isArray(sx) ? sx : [sx])]}>
      {isIcon ? <LogoIcon /> : <Logo reverse={reverse} />}
    </ButtonBase>
  );
}
